import {Component, OnInit} from '@angular/core';
import {TlPagination} from "../../../interfaces/general-interfaces";
import {AuthenticationHttpService} from "../../../services/http-services/authentication/authentication-http.service";
import {PAGES_AND_PATHS} from "../../../constants/pages-and-paths";
import {Router} from "@angular/router";

@Component({
  selector: 'tl-select-topics',
  templateUrl: './select-topics.component.html',
})
export class SelectTopicsComponent implements OnInit {
  topics: any[] = [];
  topicIds: any[] = [];
  numberOfSelectedTopics = 0;
  topicsPagination: TlPagination | undefined;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private authHttpService: AuthenticationHttpService, private router: Router) {
  }

  ngOnInit(): void {
    this.getTopics();
  }

  getTopics(): void {
    const page = this.topicsPagination?.currentPage ? this.topicsPagination.currentPage + 1 : 1;
    this.authHttpService.getTopics({page}).then(res => {
      this.topics = [...this.topics, ...res.data];
      this.topicsPagination = res.pagination;
      this.getSelectedTopics();
    });
  }

  getSelectedTopics(): void {
    this.authHttpService.getUserTopics().then(res => {
      this.numberOfSelectedTopics = res.data.length;
      res.data.forEach((selectedTopic: any) => {
        const selectedTopicIndex = this.topics.findIndex((topic: any) => {
          return selectedTopic.id === topic.id;
        })
        if (selectedTopicIndex !== -1) {
          this.topics[selectedTopicIndex].selected = true;
        }
      })
    })
  }

  onScroll(event: any): void {
    const threshold = 1;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;
    if (position > height - threshold && (this.topicsPagination?.currentPage ?? 0) < (this.topicsPagination?.lastPage ?? 0)) {
      this.getTopics();
    }
  }

  onSelectTopicChange(topic: any): void {
    if (topic.selected) {
      this.numberOfSelectedTopics++
      this.topicIds.push(topic.id);
    } else {
      this.numberOfSelectedTopics--
      this.topicIds = this.topicIds.filter(id => id !== topic.id);
    }
  }

  onClickToContinue(): void {
    this.authHttpService.bulkToggleSubcategoriesV2({ids: this.topicIds}).finally(() => {
      this.router.navigate([PAGES_AND_PATHS.home.pagePath]);
    });
  }
}
